import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import InputBase from '@material-ui/core/InputBase';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { colors } from '../../theme';

const styles = theme => ({
  formControl: {
    width: '100%',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  root: {
    'label + &': {
      marginTop: theme.spacing.unit * 3,
    },
  },
  input: {
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 12px',
    maxWidth: '100%',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderColor: colors.primary,
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  formLabel: {
    fontSize: 18
  },
})

const InputField = props => {
  const { classes } = props
  return (
    <FormControl className={classes.formControl}>
      <InputLabel shrink htmlFor={props.name} className={classes.formLabel} style={{color: props.color ? props.color : '#fff'}}>
        {props.label}
      </InputLabel>
      <InputBase
        id={props.name}
        name={props.name}
        type={props.type}
        required={props.required}
        classes={{
          root: classes.root,
          input: classes.input,
        }}
      />
    </FormControl>
  )
}

export default withStyles(styles)(InputField)


// WEBPACK FOOTER //
// ./src/elements/Form/Inputfield.js